
define('text!vb/types/instanceFactory/builtinTypes.json',[],function () { return '{\n  "types": {\n    "vb/ServiceDataProvider2": {\n      "typeDef": "./vbServiceDataProvider2/index.d.ts"\n    },\n    "vb/MultiServiceDataProvider2": {\n      "typeDef": "./vbMultiServiceDataProvider2/index.d.ts"\n    }\n  }\n}\n';});

